import React from 'react';
import { connect } from 'react-redux';
import BaseOptionGroupNote from '@gcc/countertops-components/dist/OptionGroupNote'; // need to port
import { NoteWrapper } from './optionGroupStyles';

const OptionGroupNote = (props) => <NoteWrapper><BaseOptionGroupNote {...props} /></NoteWrapper>;

export const InteriorCornersNote = connect(({ draftingTool: { totalInteriorCorners } }) => ({
  hidden: !totalInteriorCorners,
  children: `Your countertop design supports up to ${totalInteriorCorners} interior angles.`,
}))(OptionGroupNote);

export const ExteriorCornersNote = connect(({ draftingTool: { totalExteriorCorners } }) => ({
  hidden: !totalExteriorCorners,
  children: `Your countertop design supports up to ${totalExteriorCorners} finished corners.`,
}))(OptionGroupNote);
